/* eslint-disable no-unused-vars */
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export default function initSwipers() {
    const nodes = document.querySelectorAll('.default-swiper');

    nodes.forEach((swiperEl) => {
        const wrapper = swiperEl.closest('.js-swiper-wrapper');
        const slides = swiperEl.dataset.slidesPerView || 1;
        const fixedPerView = swiperEl.dataset.fixedPerView || false;
        const autoplayDelay = swiperEl.dataset.autoplayDelay;

        const next = wrapper?.querySelector('.swiper-button-next');
        const prev = wrapper?.querySelector('.swiper-button-prev');
        const pagination =
            swiperEl.querySelector('.swiper-pagination') ||
            wrapper?.querySelector('.swiper-pagination');

        const config = {
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            slidesPerView: fixedPerView ? slides : 1,
            spaceBetween: Number(slides) > 1 ? 20 : 0,
            breakpoints: {
                768: {
                    slidesPerView: slides
                }
            },
            navigation: {
                nextEl: next,
                prevEl: prev
            },
            pagination: {
                el: pagination,
                clickable: true
            }
        };

        if (autoplayDelay) {
            config.autoplay = {
                delay: parseInt(autoplayDelay, 10)
            };
        }

        new Swiper(swiperEl, config);
    });
}
